import React, { Component } from 'react';
import Modal from 'react-modal';
import {connect} from 'react-redux';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import secondaryApp from '../BD/secondaryApp';
import store from '../../store';
import MapaModal from '../Rutas/mapaModal';
import SearchBox from 'react-google-maps/lib/components/places/SearchBox'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { sendLog } from '../../util'

const database = firebase.database();
const google = window.google;

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '450px',
		height: '550px',

	}
};


class Modal_empleados extends Component {


	constructor(props) {

		super(props)
		this.state = {
			uid: '',
			isActive: false,
			nodo: props.nodo,
			isActiveCosto: false,
			dui:'',
			nom: '',
			Costos: [],
			codCosto: '',
			empresaUID: '',
			coordenadas: [],
			localizacionL: { coordenadas: { lat: 13.6988044, lng: -89.2507203 }, eta: 0, referencia: '', placeName: '' },
			rutas: []
		}

		this.setMarkerG = this.setMarkerG.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.insertRow = this.insertRow.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.handleKeyPressNumeros = this.handleKeyPressNumeros.bind(this);

		this.empleadosRef = database.ref().child('empleado_empresa');
		this.clientesRef = database.ref().child('Clientes');
		this.costosRef = database.ref().child('CentroCosto');

	}


	handleClick() {



	}

	toggleModalG(index) {
		let active = 'isActive' + index;
		this.setState({
			[active]: !this.state[active]
		})
	}

	toggleModal() {

		this.setState({

			isActive: !this.state.isActive

		})
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	handleChange(event, index) {
		let id = 'localizacion' + index;
		this.setState({ [id]: { ...this.state[id], referencia: event.target.value } })
	}

	setMarkerG(e, index, para) {
		let lat2 = 0;
		let lng2 = 0;
		if (para === 1) {
			lat2 = e.lat();
			lng2 = e.lng();
		}
		else {
			lat2 = e.latLng.lat();
			lng2 = e.latLng.lng();
		}
		let marker = 'showMarker' + index;
		let coordenadas = { lat: Number(lat2), lng: Number(lng2) }
		let id = 'localizacion' + index;

		fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat2 + ',' + lng2 + '&key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M')
			.then(response => response.json())
			.catch(error => error)
			.then(responseJSON => {
				let nombreP = responseJSON.results[0].formatted_address;
				this.setState({ [id]: { ...this.state[id], coordenadas: coordenadas, placeName: nombreP }, [marker]: true })
			})
	}

	onPlacesBusqueda = (index) => {
		const places = this.searchBox.getPlaces();
		const bounds = new google.maps.LatLngBounds();
		places.forEach(place => {
			if (place.geometry.viewport) {
				bounds.union(place.geometry.viewport)
			} else {
				bounds.extend(place.geometry.location)
			}
		});
		const nextMarkers = places.map(place => ({
			position: place.geometry.location,
		}));
		let e = nextMarkers[0].position;
		this.setMarkerG(e, index, 1)
	}

	insertRow(event) {


		let correo = this.correoEmpleado.value;
		let pass = this.contrasenaEmpleado.value;
		let con_pass = this.confirEmpleado.value;
		let dui = this.duiEmpleado.value;
		let direccion = this.direccion.value;
		let referencias = this.referencias.value;
		let escalafon = this.escalafon.value;
		let localizacionL = this.state.localizacionL;
		let numero_empleado = this.numeroEmpleado.value;
		let nombre = this.nombreEmpleado.value;
		let apellido = this.apellidoEmpleado.value;
		let preferencia = this.preferencia.value;
		let centro = this.state.codCosto;
		let area = this.area.value;
		let tipoEmple = this.tipoEmpleado.value


		//Registrar en el auth
		if (pass === con_pass) {

			secondaryApp.auth().createUserWithEmailAndPassword(correo, pass)
				.then(user => {

					const idKey = this.clientesRef.child(user.user.uid).update({

						apellido: apellido,
						nombre: nombre,
						correo: correo,
						numero_empleado: numero_empleado,
						dui: dui,
						direccion: direccion,
						referencias: referencias,
						escalafon: escalafon,
						coordenadas: localizacionL,
						centro: centro,
						estado: 'Activo',
						socio: store.getState().nodo_empresa,
						subir: false,
						viaje: 'desactivo',
						viajeActual: 'ninguno',
						preferencia: preferencia,
						areaDesc: area,
						latitud: -89.20134488794466,
						longitud: 13.701950380252162,
						tipoEmple
					}).key
					
					sendLog({ tipo: 'empleado_avianca_nuevo', informacion_extra: {conductor: user.user.uid} });
					this.toggleModal();
					secondaryApp.auth().signOut();
					Alert.success('Datos guardados con exito', {
						effect: 'genie',
						position: 'bottom-right',
						timeout: 2000
					});
				})
				.catch(error => {

					let msj = error;

					if (error.code === 'auth/email-already-in-use') {
						msj = 'Ya existe una cuenta con la dirección de correo electrónico especificada.';
					}
					else if (error.code === 'auth/invalid-email') {
						msj = 'Dirección de correo electronico no valida.';
					}

					else if (error.code === 'auth/weak-password') {

						msj = 'La contraseña ingresada no es demasiado fuerte.';

					}

					Alert.error(msj, {
						effect: 'genie',
						position: 'bottom-right',
						timeout: 2000
					});


				});
		}
		else {

			Alert.error('Las contraseñas ingresadas no coinciden', {
				effect: 'genie',
				position: 'bottom-right',
				timeout: 2000
			});
		}

		event.preventDefault();
	}

	handleKeyPressNumeros(e) {

		let tecla = e.which;
		let patron = /^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);

		let rs = patron.test(tecla_final);

		if (!rs) {
			e.preventDefault();
		}

	}

	//validar el estado del modal 
	toggleModalCosto = () => {
		this.setState({

			isActiveCosto: !this.state.isActiveCosto

		})
	}

	componentWillMount() {
		Modal.setAppElement('body');
		let uid = this.props.EmpresaUID;
		this.setState({ empresaUID: uid })
	}


	componentDidMount() {
		this.costosRef.once('value', this.gotDataCostos, this.errDataTipos);
	}

	gotDataCostos = (data) => {
		let Datos = [];
		const Base = data.val();
		if (data.val() !== null) {
			const keys = Object.keys(Base);
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				if (Base[k].empresa === this.state.empresaUID) {
					Datos.push({
						key: k,
						codigo: Base[k].codigo,
						descripcion: Base[k].descripcion,
						responsable: Base[k].responsable,
						area: Base[k].area
					})
				}
			}
			this.setState({ Costos: Datos });
		}
	}
	errDataSocios = (err) => {

		console.log(err);

	}

	btnCostosFormatter(cell, row) {

		return <button className="btn btn-success btn-sm" onClick={() => { this.handleClickCostos(row) }} >Seleccionar</button>;
	}

	handleClickCostos = (rowKey) => {


		this.state.nom = rowKey.codigo;
		this.state.codCosto = rowKey.key;

		this.toggleModalCosto();

	}

	handlerDui = (evt) =>{
		const val = evt.target.value;
		const pattern = new RegExp('^[0-9]*$');
		if(pattern.test(val))
			this.state.dui=val;

		evt.target.value=this.state.dui;
	}

	render() {

		return (

			<div>
				<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>



				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal} style={customStyles}>

					<form method="POST" action="" onSubmit={this.insertRow}>

						<h3>Agregar Empleado</h3>

						<hr />
						<div className="form-group">
							<label htmlFor="nombre">Nombre</label>
							<input type="text" className="form-control" name="nombre"
								placeholder="Nombre" required autoComplete="off"
								ref={input => { this.nombreEmpleado = input }}
							/>
						</div>
						<div className="form-group">
							<label htmlFor="apellido">Apellido</label>
							<input type="text" className="form-control" name="apellido"
								placeholder="Apellido" required autoComplete="off"
								ref={input => { this.apellidoEmpleado = input }}
							/>
						</div>
						<div className="form-group">
							<label htmlFor="correo">Correo:</label>
							<input type="text" className="form-control" name="correo"
								placeholder="Correo" required autoComplete="off"
								ref={input => { this.correoEmpleado = input; }}
							/>
						</div>
						<div className="form-group">
							<label htmlFor="contrasena">Contraseña</label>
							<input type="password" className="form-control" name="contrasena"
								placeholder="Contraseña" required autoComplete="off"
								ref={input => { this.contrasenaEmpleado = input; }}
							/>
						</div>
						<div className="form-group">
							<label htmlFor="confirmar-contrasena">Contraseña</label>
							<input type="password" className="form-control" name="confirmar-contrasena"
								placeholder="Confirmar contraseña" required autoComplete="off"
								ref={input => { this.confirEmpleado = input; }}
							/>
						</div>

						<div className="form-group">
							<label htmlFor="tipoEmpleado">Tipo empleado:</label>
							<select name="tipoEmpleado" defaultValue={this.state.tipoEmpleado} className="form-control"
								ref={input => { this.tipoEmpleado = input }}>
								<option>Piloto</option>
								<option>Tripulante de cabina</option>
								<option>Personal tierra</option>
							</select>
						</div>


						<div className="form-group">
							<label htmlFor="numero_empleado">Numero de empleado:</label>
							<input type="text" className="form-control" name="numero_empleado"
								placeholder="Numero de empleado" required autoComplete="off"
								ref={input => { this.numeroEmpleado = input; }}
							/>
						</div>

						<div className="form-group">
							<label htmlFor="dui">Dui:</label>
							<input type="text" className="form-control" name="dui"
								placeholder="Dui" required autoComplete="off"
								ref={input => { this.duiEmpleado = input }}
								onChange={this.handlerDui}
								maxLength="9"
							/>
						</div>

						<div className="form-group">
							<label htmlFor="direccion">Dirección:</label>
							<textarea className="form-control" name="direccion"
								placeholder="Dirección" required autoComplete="off"
								ref={input => { this.direccion = input }}
							/>
						</div>

						<div className="form-group">
							<label htmlFor="referencias">Referencias:</label>
							<input type="text" className="form-control" name="referencias"
								placeholder="Referencias" required autoComplete="off"
								ref={input => { this.referencias = input }}
							/>
						</div>

						<div className="form-group">
							<label htmlFor="escalafon">Escalafón:</label>
							<input type="number" className="form-control" name="direccion"
								placeholder="Escalafón" required autoComplete="off"
								ref={input => { this.escalafon = input }}
								min="0" max="150" step="1" />
						</div>

						<div className="form-group">
							<label htmlFor="localizacionL">Localización</label>
							<input type="text" defaultValue={this.state['localizacionL'].placeName} onClick={() => this.toggleModalG('L')} className="form-control" readOnly={true} placeholder="Ingrese ubicación" />
						</div>

						<div className="form-group">
							<label htmlFor="nombre">Area</label>
							<input type="text" className="form-control" name="nombre"
								placeholder="Area" required autoComplete="off"
								ref={input => { this.area = input }}
							/>
						</div>

						<div className="form-group">
							<label htmlFor="cento">Centro Costo</label>
							<input type="text" className="form-control"
								ref={input => { this.cod = input; }}
								readOnly="readonly" required autoComplete="off"
								onClick={this.toggleModalCosto}
								placeholder="Ejile una Centro de costos"
								value={this.state.nom}
							/>
						</div>



						<div className="form-group">
							<label htmlFor="preferencia">Preferencia:</label>
							<select className="form-control"
								ref={input => { this.preferencia = input }}
							>
								<option>Taxi</option>
								<option>Microbus</option>
								<option>Privado</option>
								<option>Todos</option>
							</select>
						</div>



						<button className="btn btn-primary buttons" type="submit" >Guardar</button>
					</form>
					<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
				</Modal>

				<Modal key={'modalL'} isOpen={this.state['isActiveL']} onRequestClose={() => this.toggleModalG('L')} style={customStyles}>
					<MapaModal
						googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M&v=3.exp&libraries=geometry,drawing,places"
						loadingElement={<div style={{ height: '100%', }} />}
						containerElement={<div style={{ height: '100%' }} />}
						mapElement={<div style={{ height: '100%', width: '100%' }} />}
						setMarker={(e) => this.setMarkerG(e, 'L', 0)}
						coordenadas={this.state['localizacionL'].coordenadas}
						showMarker={this.state['showMarkerL']}>
						<SearchBox
							ref={refs => this.searchBox = refs}
							onPlacesChanged={() => this.onPlacesBusqueda('L')}
							bounds={new google.maps.LatLngBounds(new google.maps.LatLng(Number(13.6988044), Number(-89.2507203)))}
							controlPosition={1}>
							<input
									type="text"
									defaultValue="San Salvador"
									className="validate"
									style={{
										boxSizing: `border-box`,
										border: `1px solid transparent`,
										width: `35%`,
										height: `40px`,
										marginTop: '10px',
										padding: `0 12px`,
										borderRadius: `3px`,
										boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
										fontSize: `14px`,
										fontColor: `black`,
										outline: `none`,
										textOverflow: `ellipses`,
									}}
								/>
						</SearchBox>
					</MapaModal>
				</Modal>

				<Modal isOpen={this.state.isActiveCosto} onRequestClose={this.toggleModalCosto} style={customStyles}>
					<h4>Selecciona un Centro de costos</h4>
					<hr />

					<BootstrapTable data={this.state.Costos}
						ref='table'
						pagination={true}
						search={true}
						hover
					>
						<TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						<TableHeaderColumn dataField='codigo' dataSort={true}  >Codigo</TableHeaderColumn>
						<TableHeaderColumn dataField='area' dataSort={true}  >Area</TableHeaderColumn>
						<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={this.btnCostosFormatter.bind(this)}>Seleccionar</TableHeaderColumn>
					</BootstrapTable>

				</Modal>


			</div>


		);

	}

}

const mapStateToProps = (state)=>({
	EmpresaUID:state.nodo_empresa
});

export default connect(mapStateToProps,null)(Modal_empleados);


// WEBPACK FOOTER //
// ./src/Components/Emp_Empresas/Modal_empleados.js